import { queryOptions } from '@tanstack/react-query';
import type { ServiceAdminListQuery, ServiceDto, ServiceListResponse } from '@upme/contracts';
import { api } from '../../app/api-client';

export const servicesKey = ['admin', 'services'] as const;

export type ServiceListFilters = Omit<ServiceAdminListQuery, 'limit' | 'cursor'> & { limit?: number };

function buildSearchParams(filters: ServiceListFilters): URLSearchParams {
  const params = new URLSearchParams();
  for (const [k, v] of Object.entries(filters)) {
    if (v === undefined || v === null || v === '') continue;
    params.set(k, String(v));
  }
  return params;
}

export const listServicesOptions = (filters: ServiceListFilters = {}) =>
  queryOptions({
    queryKey: [...servicesKey, 'list', filters] as const,
    queryFn: () =>
      api
        .get('admin/services', { searchParams: buildSearchParams({ limit: 50, ...filters }) })
        .json<ServiceListResponse>(),
    staleTime: 10_000,
  });

export const serviceByIdOptions = (id: string) =>
  queryOptions({
    queryKey: [...servicesKey, id] as const,
    queryFn: () => api.get(`admin/services/${id}`).json<ServiceDto>(),
  });
